import {
	type AdminEpisodeDetail,
	type AdminEpisodeSummary,
	type AdminProductionProgress,
	type CoverUploadResponse,
	type CreateEpisodeInput,
	coverUploadResponseSchema,
	type ProductionState,
	type ReplaceStoryGraphInput,
	type UpdateEpisodeInput,
} from "@storyline/shared";
import { env } from "@/src/common/constants/env";
import { unwrap } from "@/src/common/services/api-error";
import { putBinary } from "@/src/common/services/binary-upload.service";
import { httpClient, request } from "@/src/common/services/http.service";

export const createEpisode = async (seriesId: string, body: CreateEpisodeInput): Promise<AdminEpisodeSummary> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).episodes.post(body)));

export const getEpisode = async (id: string): Promise<AdminEpisodeDetail> =>
	unwrap(await request(() => httpClient.admin.stories({ id }).get()));

export const updateEpisode = async (id: string, body: UpdateEpisodeInput): Promise<AdminEpisodeSummary> =>
	unwrap(await request(() => httpClient.admin.stories({ id }).put(body)));

export const replaceEpisodeGraph = async (id: string, body: ReplaceStoryGraphInput): Promise<void> => {
	unwrap(await request(() => httpClient.admin.stories({ id }).graph.put(body)));
};

export const uploadEpisodeCover = async (id: string, file: File): Promise<CoverUploadResponse> => {
	const response = await putBinary(`${env.SERVER_URL}/admin/stories/${id}/cover`, file);
	return coverUploadResponseSchema.parse(await response.json());
};

export const publishEpisode = async (id: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.stories({ id }).publish.post()));
};

export const unpublishEpisode = async (id: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.stories({ id }).unpublish.post()));
};

export const deleteEpisode = async (id: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.stories({ id }).delete()));
};

export const transitionProduction = async (id: string, to: ProductionState): Promise<AdminProductionProgress> =>
	unwrap(await request(() => httpClient.admin.stories({ id }).production.transition.post({ to })));

export const getProduction = async (id: string): Promise<AdminProductionProgress> =>
	unwrap(await request(() => httpClient.admin.stories({ id }).production.get()));
